"use client";

import React, { createContext, useContext, useMemo, useState } from "react";

interface PreferencesContextValue {
  usePreferences: boolean;
  setUsePreferences: (value: boolean) => void;
}

const PreferencesContext = createContext<PreferencesContextValue | undefined>(undefined);

export const PreferencesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [usePreferences, setUsePreferences] = useState<boolean>(false);

  const value = useMemo<PreferencesContextValue>(
    () => ({ usePreferences, setUsePreferences }),
    [usePreferences]
  );

  return <PreferencesContext.Provider value={value}>{children}</PreferencesContext.Provider>;
};

export const usePreferences = (): PreferencesContextValue => {
  const ctx = useContext(PreferencesContext);
  if (!ctx) {
    throw new Error("usePreferences must be used within a PreferencesProvider");
  }
  return ctx;
};
